
import { nextTick } from "process";
import { defineComponent, onBeforeMount, watch } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "RelationHeader",
  props: {
    disabledSaveButton: {
      type: Boolean
    },
    buttonTitle: {
      type: String,
      required: true
    }
  },
  setup(_, { emit }) {
    const route = useRoute();

    onBeforeMount(async () => {
      nextTick(() => {
        let input: HTMLInputElement | null = document.querySelector(
          "[data-search-input]"
        );
        if (input) {
          if (route.query.search) {
            input.value = route.query.search.toString();
          } else {
            input.value = "";
          }
          input.focus();
        }
      });
    });

    watch(
      () => route.query.search,
      () => {
        let input: HTMLInputElement | null = document.querySelector(
          "[data-search-input]"
        );
        if (input) {
          if (route.query.search) {
            input.value = route.query.search.toString();
          } else {
            input.value = "";
          }
          input.focus();
        }
      }
    );

    /** Clear search input and emit an event to close modal. */
    const close = (): void => {
      let input: HTMLInputElement | null = document.querySelector(
        "[data-search-input]"
      );
      if (input) {
        input.value = " ";
      }
      emit("relateEntities");
    };

    return {
      close
    };
  }
});
